import { Modal } from "@ucchub/ui";
import { SuccessModalContent } from "@ucchub/ui/src/Modal";
import { ReactNode } from "react";

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  heading: string;
  body: ReactNode;
  confirmText: string;
};

const AddBillingContextSuccessModel = ({
  isOpen,
  onClose,
  heading,
  body,
  confirmText,
}: Props) => {
  const handleOnClose = () => {
    onClose?.();
  };

  return (
    <Modal
      srName="Add Billing Context Success"
      isOpen={isOpen}
      size={2}
      animate
      isClosable
      onClose={handleOnClose}
    >
      <SuccessModalContent
        heading={heading}
        body={body}
        confirmText={confirmText}
        onConfirm={handleOnClose}
      />
    </Modal>
  );
};

export default AddBillingContextSuccessModel;
